export const VIRTUAL_GIFT_METADATA_KEY = 'virtualGift'

export const pluralize = (word: string, count: number) => {
  const singular = word.replace(/s$/, '')

  if (count === 1) return singular

  if (/(?:s|x|z|ch|sh)$/i.test(singular)) return `${singular}es`

  return `${singular}s`
}
